import { Box, Typography } from '@mui/material';
import type { Datasource } from '../../model/types';
import { DatasourceStatus, DatasourceType } from '../../model/types';
import { DatasourceIds } from '../../model/useDatasources';
import { StatusIndicator } from '../StatusIndicator/StatusIndicator';

export const DATASOURCE_TYPE_LABEL_MAP: Record<DatasourceType, string> = {
  [DatasourceType.attribution]: 'Attribution',
  [DatasourceType.marketingSpend]: 'Marketing spend',
  [DatasourceType.monetization]: 'Monetization',
  [DatasourceType.affiliateNetwork]: 'Affiliate network',
};

interface Props {
  datasource: Datasource;
}

export function DatasourceCard({ datasource }: Props) {
  const isCustom = datasource.id === DatasourceIds.custom;

  return (
    <Box
      sx={{
        height: '100%',
        p: 2,
        pt: 1.5,
        borderRadius: 3,
        border: '1px solid  #DDDFE7',
        backgroundColor:
          datasource.status === DatasourceStatus.active ? '#F1F3F8' : 'white',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Box
          component="img"
          alt={`${datasource.name} logo`}
          src={datasource.iconUrl}
          sx={{
            width: 80,
            height: 80,
            borderRadius: 2,
            border: '2px solid #DDDFE7',
            objectFit: 'contain',
            backgroundColor: 'white',
          }}
        />
        <StatusIndicator status={datasource.status} />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography
          sx={{
            fontSize: '1.25rem',
            lineHeight: '1.5rem',
            fontWeight: 500,
            color: 'text.primary',
          }}
        >
          {datasource.name}
        </Typography>
        <Typography
          sx={{
            color: '#7E828F',
            fontSize: '0.875rem',
            lineHeight: '1.125rem',
          }}
        >
          {isCustom ? '' : DATASOURCE_TYPE_LABEL_MAP[datasource.type]}
        </Typography>
      </Box>
    </Box>
  );
}
